import { ErrorCode, hasErrorCode } from '../graphql';
import { HandleChangePasswordErrorCallbacks, HandleSignInErrorCallbacks } from './types';

export const handleChangePasswordError = (error: Error | unknown, callbacks: HandleChangePasswordErrorCallbacks) => {
  if (hasErrorCode(error, ErrorCode.InvalidPassword)) {
    callbacks.onInvalidPassword?.();
  }
  if (hasErrorCode(error, ErrorCode.InvalidUsernameOrPassword)) {
    callbacks.onInvalidPassword?.();
  }
  if (hasErrorCode(error, ErrorCode.PasswordChangeLimitExceeded)) {
    callbacks.onPasswordChangeLimitExceeded?.();
  }
};

export function handleSignInError(error: Error | unknown, callbacks: HandleSignInErrorCallbacks) {
  if (hasErrorCode(error, ErrorCode.InvalidUsernameOrPassword)) {
    return callbacks.onInvalidUsernameOrPassword?.();
  } else if (hasErrorCode(error, ErrorCode.UserNotFound)) {
    return callbacks.onUserNotFound?.();
  } else {
    return callbacks.onUnknownError?.();
  }
}
